import { toast } from 'sonner';
import { isTauri } from './platform';

const CHECK_EVERY_MS = 6 * 60 * 60 * 1000;
let started = false;
let ready = false;

/**
 * Desktop only: checks the signed update manifest at startup and every 6 hours, downloads in the background,
 * then asks staff to restart. It never restarts by itself, so an update can't interrupt an order at the counter.
 */
export function startUpdateChecks(): void {
  if (!isTauri || started) return;
  started = true;
  void checkForUpdate();
  setInterval(() => void checkForUpdate(), CHECK_EVERY_MS);
}

async function checkForUpdate(): Promise<void> {
  if (ready) return;
  try {
    const { check } = await import('@tauri-apps/plugin-updater');
    const update = await check();
    if (!update) return;
    // On Windows the installer takes over when this resolves (passive mode) and restarts the app itself.
    await update.download();
    ready = true;
    toast(`Update ${update.version} is ready`, {
      description: 'Restart when the counter is quiet. Nothing is lost.',
      duration: Infinity,
      action: {
        label: 'Restart now',
        onClick: () =>
          void (async () => {
            await update.install();
            const { relaunch } = await import('@tauri-apps/plugin-process');
            await relaunch();
          })(),
      },
    });
  } catch (err) {
    // Offline, manifest missing or a bad signature: try again at the next interval.
    console.warn('[updater] check failed', err);
  }
}
